module.exports = __webpack_public_path__ + "img/info-24px.c521e356.svg";